<template>
    <v-snackbar v-model="show" top centered :color="color" :timeout="timeout">
        <v-row>
            <v-col lg="10" md="10" sm="10" align="center">
                <strong>{{ message }}</strong>
            </v-col>
            <v-col lg="2" md="2" sm="2">
                <v-btn small color="white" text @click.native="show = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-col>
        </v-row>
    </v-snackbar>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            top: true,
            message: "",
            color: "",
            timeout: 6000
        };
    },
    created: function () {
        this.$store.watch(
            state => state.snackbar.snack,
            () => {
                const message = this.$store.state.snackbar.snack.message;
                if (message) {
                    this.show = true;
                    this.message = message;
                    this.timeout = this.$store.state.snackbar.snack.timeout || 6000;
                    this.color = this.$store.state.snackbar.snack.color || "info";
                    this.$store.commit("snackbar/setSnack", {});
                }
            }
        );
    }
};
</script>